import { useForm } from "react-hook-form";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import api from "../../services/api";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import ModalRecoveryPassword from "../../components/Modals/ModalRecoveryPassword";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { LabeledStyledInputComponent } from "../../components/StyledInput";
import Background from "../../assets/svg/hour.svg";
import LogoJSM from "../../assets/svg/logo-white.svg";
import { messageError } from "../../utils/message";
import LoadingSpinner from "../../components/LoadingSpinner";
import ButtonVariant from "../../components/ButtonVariant/Button";

const Login = () => {
  const navigate = useNavigate();
  const [openModalRecPass, setOpenModalRecPass] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [loading, setloading] = useState(false);

  const token = localStorage.getItem("@token");

  useEffect(() => {
    if (token) {
      try {
        const user = jwt_decode(token);
        if (user) {
          navigate("/apontamento");
        }
      } catch (error) { }
    }
  }, []);

  const formSchema = yup.object().shape({
    username: yup
      .string()
      .email("Digite um email válido")
      .required("Email Obrigatório"),
    password: yup.string().required("Senha obrigatória"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
  });

  const submitForm = async (data) => {
    setloading(true);
    const recaptchaToken = await executeRecaptcha();
    data.recaptchaToken = recaptchaToken;
    api
      .post("/auth", data)
      .then((resp) => {
        const getToken = resp.data.data;
        localStorage.setItem("@token", getToken);
        const user = jwt_decode(getToken);
        localStorage.setItem("@userdata", JSON.stringify(user.user));
      })
      .then((_) => navigate("/apontamento"))
      .catch((err) => {
        if (err.response?.status === 403) {
          messageError("Email ou senha inválidos!");
        } else if (err.response?.status === 401) {
          localStorage.clear();
          messageError("Token expirado");
          navigate("/");
        } else {
          messageError("Falha na comunicação com o servidor");
        }
      }).finally(() => {
        setloading(false);
      }
      );
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="bg-neuter-100 min-h-screen flex justify-center items-center px-4">
      <div className="w-[80%] flex flex-row items-center gap-20">

        <div className="hidden md:flex relative h-[90vh]">
          <img src={Background} alt="background login" className="w-full h-full object-cover" />
          <div className="absolute h-full left-0 w-full px-12 flex flex-col pt-10 pb-44 justify-between">
            <img src={LogoJSM} alt="Logo JSM" width={100} />
            <div className="flex flex-col gap-6 text-center px-8 py-12 text-white rounded-md border border-white/10 bg-white/10 backdrop-blur-[15px]">
              <h2 className="text-4xl font-medium">Controle e produtividade<br />no seu dia</h2>
              <p className="text-2xl font-light">
                Registre suas tarefas diárias em poucos cliques<br />
                e mantenha sua jornada organizada e transparente.
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col flex-1 justify-center lg:px-40 items-end">
          <form className="w-full text-neuter-600 flex flex-col gap-20" onSubmit={handleSubmit(submitForm)}>
            <div className="flex flex-col gap-6">
              <h1 className="text-5xl font-bold text-center">Acesse sua conta</h1>
              <p className="text-2xl text-center">
                Entre com seu e-mail e senha para registrar suas atividades
              </p>
            </div>

            <div className="flex flex-col gap-6 ">
              <LabeledStyledInputComponent
                label="E-mail"
                id="username"
                name="username"
                register={register("username")}
                className="style-input"
                placeholder="Digite seu e-mail"
              />

              <div className="relative flex flex-col gap-2">
                <LabeledStyledInputComponent
                  label="Senha"
                  id="password"
                  name="password"
                  register={register("password")}
                  className="style-input"
                  type={showPassword ? "text" : "password"}
                  placeholder="Digite sua senha"
                />

                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer text-neuter-500">
                  {showPassword ? (
                    <Visibility style={{ fontSize: '18px' }} onClick={handleShowPassword} />
                  ) : (
                    <VisibilityOff style={{ fontSize: '18px' }} onClick={handleShowPassword} />
                  )}
                </div>

                <div className="w-full flex justify-end">
                  <p
                    className="text-xl cursor-pointer underline underline-offset-2 hover:text-brand-500 hover:font-medium"
                    onClick={() => setOpenModalRecPass(true)}
                  >
                    Recuperar acesso
                  </p>
                </div>
              </div>
            </div>

            <ButtonVariant.Root type="submit" disabled={loading}>
              {loading ? <LoadingSpinner loading={loading} /> : "Entrar"}
            </ButtonVariant.Root>
          </form>
        </div>
      </div>

      <ModalRecoveryPassword
        openModal={openModalRecPass}
        setOpenModal={setOpenModalRecPass}
      />
    </div>

  );
};

export default Login;
